import Vue from 'vue';
import { format, parseISO, formatRelative } from 'date-fns';
import isEmpty from 'lodash/isEmpty';
import { ptBR } from 'date-fns/locale';

Vue.filter('capitalize', function(value) {
    if (!value) return '';
    value = value.toString();
    let arr = value.split(' ');
    let capitalized_array = [];
    arr.forEach((word) => {
        let capitalized = word.charAt(0).toUpperCase() + word.slice(1);
        capitalized_array.push(capitalized);
    });
    return capitalized_array.join(' ');
});

Vue.filter('truncate', function(value, limit) {
    return value.substring(0, limit);
});

Vue.filter('tailing', function(value, tail) {
    return value + tail;
});

Vue.filter('time', function(value, is24HrFormat = false) {
    if (value) {
        const date = new Date(Date.parse(value));
        let hours = date.getHours();
        const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
        if (!is24HrFormat) {
            const time = hours > 12 ? 'AM' : 'PM';
            hours = hours % 12 || 12;
            return hours + ':' + min + ' ' + time;
        }
        return hours + ':' + min;
    }
});

Vue.filter('date', function(value, fullDate = false) {
    if (isEmpty(value)) {
        return 'Data não encontrada';
    }

    value = parseISO(value);

    if (fullDate) {
        value = format(value, 'dd/MM/yyyy');
    } else {
        value = format(value, 'dd/MM');
    }

    return value;
});

Vue.filter('relativeDate', function(value) {
    if (isEmpty(value)) {
        return 'Data não encontrada';
    }

    value = parseISO(value);

    value = formatRelative(value, new Date(), { locale: ptBR });

    return value;
});

Vue.filter('month', function(val, showYear = true) {
    val = String(val);

    const regx = /\w+\s(\w+)\s\d+\s(\d+)./;
    if (!showYear) {
        return regx.exec(val)[1];
    } else {
        return regx.exec(val)[1] + ' ' + regx.exec(val)[2];
    }
});

Vue.filter('csv', function(value) {
    return value.join(', ');
});

Vue.filter('filter_tags', function(value) {
    return value.replace(/<\/?[^>]+(>|$)/g, '');
});

Vue.filter('k_formatter', function(num) {
    return num > 999 ? (num / 1000).toFixed(1) + 'k' : num;
});

Vue.filter('access_level', function(value) {
    let label = value;

    switch (label) {
        case 'administrator':
            label = 'Administrador';
            break;

        case 'restrict':
            label = 'Todos os irmãos';
            break;

        case 'specific_restriction':
            label = 'Irmãos (apenas selecionados)';
            break;

        case 'public':
            label = 'Público';
            break;
    }

    return label;
});
